import { render, staticRenderFns } from "./ListTopFilters.vue?vue&type=template&id=48e51aa3"
import script from "./ListTopFilters.vue?vue&type=script&lang=js"
export * from "./ListTopFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports